import apiCalls from "@/mixins/apiCalls.js";
import { mapActions } from "vuex";

const APP_ACTION = false

export default {
  mixins: [apiCalls],
  methods: {
        ...mapActions([
          "setUserProfile",       
        ]),
     async getUser(user) {
      //  console.log('fetch user : ', user);
        const functionName = "get_user_info";
        const reqBody = {
          domain_user_id: user.domain_user_id,
        };
        const data = await this.makeApiRequest(APP_ACTION, functionName, reqBody);
        // console.log('user response : ', data);
        return data.data;
      },
    
  },
};
